/**
 * Created by Owner on 2016/8/13.
 */
import { Component, Input, Output, EventEmitter, ElementRef, AfterViewInit } from '@angular/core';
import { LotteryMath } from "./lotteryMath";
import { ToastController } from "ionic-angular";
import { AppDialog } from "../appDialog";
import { MathUtil } from "../../util/mathUtil";
import { setBindingDebugInfo } from "@angular/core/src/linker/view_utils";

@Component({
    selector: 'lottery-math-ds',
    templateUrl: 'textAreMath.html',
    styleUrls: ['/lottery-math-ds.scss']
})
export class LotteryMathDSComponent implements LotteryMath, AfterViewInit {
    typeGame;
    typeChonSo = 'nhapso';
    _selectAreaOption: any;
    textAreVal: string;
    @Output() onTotal: EventEmitter<any> = new EventEmitter<any>();
    dataSel: string[] = [];
    lt_position_sel: number;
    defaultPosition: any = [];
    isHasTip: boolean = false;
    toggleGuide: boolean = true;
    descGuide: string;
    guideEx: string;
    guideTxt: string;
    private pageDom: HTMLElement;
    // generateType = 0;
    // generateTypeList = [1, 2, 3, 5, 10];

    // generateTypeGoiYSelect: string = ""
    // generateTypeGoiY = [{
    //     type: 'kb',
    //     title: 'Kép bằng',
    //     value: '00;11;22;33;44;55;66;77;88;99;'
    // },
    // {
    //     type: 'chan',
    //     title: 'Chẵn',
    //     value: '00;02;04;06;08;10;12;14;16;18;20;22;24;26;28;30;32;34;36;38;40;42;44;46;48;50;52;54;56;58;60;62;64;66;68;70;72;74;76;78;80;82;84;86;88;90;92;94;96;98;'
    // },
    // {
    //     type: 'le',
    //     title: 'Lẻ',
    //     value: '01;03;05;07;09;11;13;15;17;19;21;23;25;27;29;31;33;35;37;39;41;43;45;47;49;51;53;55;57;59;61;63;65;67;69;71;73;75;77;79;81;83;85;87;89;91;93;95;97;99;'
    // },
    // {
    //     type: 'lon',
    //     title: 'Lớn',
    //     value: '50;51;52;53;54;55;56;57;58;59;60;61;62;63;64;65;66;67;68;69;70;71;72;73;74;75;76;77;78;79;80;81;82;83;84;85;86;87;88;89;90;91;92;93;94;95;96;97;98;99;'
    // },
    // {
    //     type: 'nho',
    //     title: 'Nhỏ',
    //     value: '00;01;02;03;04;05;06;07;08;09;10;11;12;13;14;15;16;17;18;19;20;21;22;23;24;25;26;27;28;29;30;31;32;33;34;35;36;37;38;39;40;41;42;43;44;45;46;47;48;49;'
    // },
    // ];

    private btnsOption = [];
    flagError: boolean = false;

    // selectedOption: string = 'ngauNhien'; // Default selected option

    // selectOption(option: string) {
    //     this.selectedOption = option;
    // }

    setSelectNo(selectNo: any) {
        this.textAreVal = selectNo.join(',');
    }

    constructor(private toastCtrl: ToastController, private elRef: ElementRef) {
        this.pageDom = elRef.nativeElement;
    }

    ngAfterViewInit() {
        this.pageDom.querySelector('#lx__iput').addEventListener('focus', (e) => {
            this.toggleGuide = false;
        });
        this.pageDom.querySelector('#lx__iput').addEventListener('blur', (e) => {
            if (this.textAreVal === '') {
                this.toggleGuide = true;
            }
        });
    }

    @Input()
    set selectAreaOption(selectAreaOption: any) {
        this.toggleGuide = true;
        if (selectAreaOption) {
            if (selectAreaOption.hasOwnProperty("defaultposition")) {
                let defaultposition = selectAreaOption["defaultposition"];
                this.btnsOption = [
                    {
                        text: "万",
                        type: "0",
                        isSelect: defaultposition[0] == "1"
                    },
                    {
                        text: "千",
                        type: "1",
                        isSelect: defaultposition[1] == "1"
                    },
                    {
                        text: "百",
                        type: "2",
                        isSelect: defaultposition[2] == "1"
                    },
                    {
                        text: "十",
                        type: "3",
                        isSelect: defaultposition[3] == "1"
                    },
                    {
                        text: "个",
                        type: "4",
                        isSelect: defaultposition[4] == "1"
                    }
                ];
            }
        }
        this.textAreVal = "";
        this.descGuide = selectAreaOption.objCustom.methoddesc;
        this.guideEx = selectAreaOption.objCustom.methodexample;
        this.guideTxt = selectAreaOption.objCustom.guideTxt;
        this._selectAreaOption = selectAreaOption;
        console.log('this._selectAreaOption',this._selectAreaOption);
        this.typeGame = this._selectAreaOption.mname;
    }

    get selectAreaOption() {
        return this._selectAreaOption;
    }

    positionLg() {
        this.defaultPosition = [];
        this.btnsOption.forEach(item => {
            if (item.isSelect) {
                this.defaultPosition.push(item);
            }
        });
        this.lt_position_sel = this.defaultPosition.length;
    }

    changeTotal() {
        let tmpTotal: number = 1;
        this.onTotal.emit({
            total: tmpTotal,
            selectNo: tmpTotal,
            type: 'digitalts'
        });
    }

    //初始化界面
    initView() {
        this.textAreVal = "";
        this.toggleGuide = true;
    }

    /**
     * 至少两个数字一样
     * @param n
     * @param len
     * @returns {boolean}
     * @constructor
     */
    ZUSDScheck(n, len) {
        if (len != 3) {
            return false
        }
        var first = "";
        var second = "";
        var third = "";
        var i = 0;
        for (i = 0; i < len; i++) {
            if (i == 0) {
                first = n.substr(i, 1)
            }
            if (i == 1) {
                second = n.substr(i, 1)
            }
            if (i == 2) {
                third = n.substr(i, 1)
            }
        }
        if (first == second && second == third) {
            return false
        }
        if (first == second || second == third || third == first) {
            return true
        }
        return false
    }

    /**
     * 三个数字都不同
     * @param n
     * @param len
     * @returns {boolean}
     * @constructor
     */
    ZULDScheck(n, len) {
        if (len != 3) {
            return false;
        }
        var first = "";
        var second = "";
        var third = "";
        let i = 0;
        for (i = 0; i < len; i++) {
            if (i == 0) {
                first = n.substr(i, 1)
            }
            if (i == 1) {
                second = n.substr(i, 1)
            }
            if (i == 2) {
                third = n.substr(i, 1)
            }
        }
        if (first == second || second == third || third == first) {
            return false;
        } else {
            return true;
        }
    }

    sortNum(a, b): any {
        a = parseInt(a, 10);
        b = parseInt(b, 10);
        if (isNaN(a) || isNaN(b)) {
            return true
        }
        return (a - b);
    }

    postionFn() {
        this.positionLg();
        this.countNum();
    }

    /**
     * Sum of number is selected by user
     */
    countNum() {
        let mname = this.selectAreaOption["mname"];
        let optionLg = 0;
        let mathFn = {
            'lo2so': () => this.lo2so(),
            'lo3so': () => this.lo3so(),
            'lo4so': () => this.lo4so(),
            'dedau': () => this.dedau(),
            'dedacbiet': () => this.dedacbiet(),
            'dedaudacbiet': () => this.dedaudacbiet(),
            'degiai7': () => this.degiai7(),
            'degiainhat': () => this.degiainhat(),
            'dedauduoi': () => this.dedauduoi(),
            'detx': () => this.detx(),
            '3cangdau': () => this.bacangdau(),
            '3cangdacbiet': () => this.bacangdacbiet(),
            '3cangdauduoi': () => this.bacangdauduoi(),
            '4cangdacbiet': () => this.boncangdacbiet(),
            'lx2': () => this.lx2(),
            'lx3': () => this.lx3(),
            'lx4': () => this.lx4(),
            'lt4': () => this.lt4(),
            'lt8': () => this.lt8(),
            'lt10': () => this.lt10()
        };

        let totalInfo = mathFn[mname]();
        let typeGame = 'input';
        if (
            mname === 'lo2so' ||
            mname === 'lo3so' ||
            mname === 'lo4so' ||
            mname === 'dedau' ||
            mname === 'dedacbiet' ||
            mname === 'dedaudacbiet' ||
            mname === 'degiai7' ||
            mname === 'degiainhat' ||
            mname === 'dedauduoi' ||
            mname === 'detx' ||
            mname === '3cangdau' ||
            mname === '3cangdacbiet' ||
            mname === '3cangdauduoi' ||
            mname === '4cangdacbiet'
        ) {
            typeGame = 'f-digital';
        }
        this.onTotal.emit({
            total: totalInfo.length,
            selectNo: totalInfo,
            defaultPosition: this.defaultPosition,
            type: typeGame
        });
    }

    lo2so() { return this.checkNumberType(2, false); }

    lo3so() { return this.checkNumberType(3, false); }

    lo4so() { return this.checkNumberType(4, false); }

    dedau() { return this.checkNumberType(2, false); }

    dedacbiet() { return this.checkNumberType(2, false); }

    dedaudacbiet() { return this.checkNumberType(2, false); }

    degiai7() { return this.checkNumberType(2, false); }

    degiainhat() { return this.checkNumberType(2, false); }

    dedauduoi() { return this.checkNumberType(2, false); }
    detx() { return this.checkNumberType(2, false); }

    bacangdau() { return this.checkNumberType(3, false); }

    bacangdacbiet() { return this.checkNumberType(3, false); }

    bacangdauduoi() { return this.checkNumberType(3, false); }

    boncangdacbiet() { return this.checkNumberType(4, false); }

    lx2() { return this.checkNumberType(2, true); }

    lx3() { return this.checkNumberType(3, true); }

    lx4() { return this.checkNumberType(4, true); }

    lt4() { return this.checkNumberType(4, true); }

    lt8() { return this.checkNumberType(8, true); }

    lt10() { return this.checkNumberType(10, true); }

    checkNumberType(digits: number, symbolAnd: boolean) {
        let dataLx = this.dataSel;
        let dataSelTemp = [];
        let checkWrongNum = false;

        for (let i = 0, len = dataLx.length; i < len; i++) {
            let item = dataLx[i];
            let getNumItem;
            let flag = false;

            if (symbolAnd) { // for loxien
                if (item.search('&') > -1) {
                    getNumItem = item.split('&');
                    if (this.checkNumDuplicateLX(getNumItem)) {
                        checkWrongNum = true;
                        break;
                    }
                    let idxNull = getNumItem.indexOf('');
                    if (idxNull > -1 && (idxNull === 0 || idxNull + 1 === getNumItem.length)) {
                        checkWrongNum = true;
                    }

                    if (getNumItem.length === digits && !checkWrongNum) {
                        for (let j = 0, lenJ = getNumItem.length; j < lenJ; j++) {
                            if (!this.checkNumLen(2, getNumItem[j])) {
                                checkWrongNum = true;
                                flag = true;
                            }
                            if ((j + 1) === digits && !flag && lenJ === digits) { // when get 2 num of xien
                                dataSelTemp.push(item.split('&').sort(this.sortNumber).join('&'));
                            }
                        }
                    } else {
                        checkWrongNum = true;
                    }
                } else {
                    checkWrongNum = true;
                }
            } else {
                if (!this.checkNumLen(digits, item)) {
                    checkWrongNum = true;
                    flag = true;
                }
                if (!flag) {
                    dataSelTemp.push(item);
                }
            }
        }

        if (checkWrongNum) {
            dataSelTemp = [];
        }

        //console.log(dataSelTemp);

        if (dataSelTemp.length > 0) {
            let checkDupli = this.removeItemDupliArr(dataSelTemp);
            if (checkDupli.flag) {
                dataSelTemp = checkDupli.result;
                //reset textarea
                this.textAreVal = dataSelTemp.join(';');
                AppDialog.toast({
                    toastCtrl: this.toastCtrl,
                    message: "Cược bị trùng. Đã tự động loại bỏ."
                });
            }
        }

        return dataSelTemp;
    }

    checkNumDuplicateLX(arr) {
        var flagCheck = false, count = 0, valTemp = arr[count], flag = true, len = arr.length, i = 1;
        while (flag) {
            if (valTemp === arr[i] && i !== count) {
                flagCheck = true;
                break;
            }
            if (i === len) {
                count += 1;
                i = count;
                valTemp = arr[count];
            }
            i += 1;
            if (!flag || i > len) break;
        }
        return flagCheck;
    }

    removeItemDupliArr(arr): any {
        if (!Array.isArray(arr) || arr.length === 0) return;
        let i,
            len = arr.length,
            result = [],
            obj = {},
            flag = false;

        // mẹo
        for (i = 0; i < len; i++) {
            if (obj[arr[i]] === undefined) {
                obj[arr[i]] = 0;
            } else {
                flag = true;
            }
        }

        for (i in obj) {
            result.push(i);
        }

        return {
            flag: flag,
            result: result
        };
    }

    sortNumber(a, b): number {
        a = parseInt(a, 10);
        b = parseInt(b, 10);
        if (isNaN(a) || isNaN(b)) {
            return 0;
        }
        return (a - b);
    };

    checkNumLen(manyNum: number, num) {
        let regexr: RegExp;

        switch (manyNum) {
            case 2:
                regexr = /^[0-9]{2}$/;
                break;
            case 3:
                regexr = /^[0-9]{3}$/;
                break;
            case 4:
                regexr = /^[0-9]{4}$/;
                break;
            default:
                break;
        }

        return regexr.test(num);
    }

    textChange(text: string) {
        let checkStrLx = /[^0-9&;,\s]/g.test(text);
        this.dataSel = [];
        if (!checkStrLx) {
            let overText = this.formatWhiteSpace(text).replace(/[,\s]/g, ';');
            let sepaVal = overText.split(';');
            let arrTemp = [];
            for (let i = 0, len = sepaVal.length; i < len; i++) {
                if (sepaVal[i] !== "") {
                    arrTemp.push(sepaVal[i]);
                }
            }
            this.dataSel = arrTemp;
        }

        this.countNum();
    }

    formatWhiteSpace(val) {
        let mname = this.selectAreaOption["mname"];
        let reformatStr = val.replace(/\s+/g, ' ').trim();
        let strTemp = '';
        let arrTemp = [];
        if (mname === 'lx2' || mname === 'lx3' || mname === 'lx4' || mname === 'lt4' || mname === 'lt8' || mname === 'lt10') {
            let symbolTemp = ';';
            if (reformatStr.search(',') > 0) symbolTemp = ',';
            if (reformatStr.search(',') > 0 || reformatStr.search(';') > 0) {
                arrTemp = reformatStr.split(symbolTemp);
                for (let i = 0, len = arrTemp.length; i < len; i++) {
                    arrTemp[i] = arrTemp[i].trim();
                    arrTemp[i] = arrTemp[i].replace(/\s+/g, '&');
                }
                reformatStr = arrTemp.join(symbolTemp);
            } else if (reformatStr !== '') {
                reformatStr = reformatStr.replace(/\s+/g, '&');
            }
        }
        return reformatStr;
    }

    // generateRandomNumbers(count: number, isDup: boolean = false) {
    //     this.generateType = count;
    //     const numbers: Set<number> | number[] = isDup ? [] : new Set();

    //     while ((isDup && (numbers as number[]).length < count) || (!isDup && (numbers as Set<number>).size < count)) {
    //         const randomNumber = Math.floor(Math.random() * 100); // Generates a random number between 0 and 99

    //         if (isDup) {
    //             (numbers as number[]).push(randomNumber); // Allow duplicates by pushing directly into array
    //         } else {
    //             (numbers as Set<number>).add(randomNumber); // Prevent duplicates by adding to Set
    //         }
    //     }

    //     // Convert the Set to an Array if duplicates are not allowed
    //     const formattedNumbers = Array.from(numbers).map(num => ('00' + num).slice(-2));


    //     this.toggleGuide = false;
    //     this.textAreVal = formattedNumbers.join(';');
    //     this.textChange(this.textAreVal);
    // }

    handleNumbersGenerated(numbers: string): void {
        this.toggleGuide = false;
        this.textAreVal = numbers;
        this.textChange(this.textAreVal);
    }

    // generateGoiY(index: string) {
    //     this.toggleGuide = false;
    //     this.generateTypeGoiYSelect = this.generateTypeGoiY[index].type;
    //     this.textAreVal = this.generateTypeGoiY[index].value;
    //     this.textChange(this.textAreVal);
    // }
}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/ds.ts